import React, { useCallback } from 'react'
import LeisureOption from '~/app/components-nds/domestic/cart/cart-product-section/items/leisure/option'
import { DomesticCartLeisureItem } from '~/api/converters/domestic/cart/ProductSection/Leisure/index.type'
import { ProductBadge, Divider } from '@yanolja-rnd/nol-design-system'
import conf from '~/app/conf'
import { isNative } from '~/app/utils/typeguards'
import { getYaNative } from '@yanolja-org/ya-native'
import { CartPageLog } from '~/app/kinesis/protobuf/clientlogs/order-misc-common-txtpb'
export interface LeisureItemProps {
  item: DomesticCartLeisureItem
}

const LeisureItem: React.FC<LeisureItemProps> = ({ item }) => {
  const { itemId, itemTitle, options } = item

  const onTitleClick = useCallback(
    async (index?: number) => {
      const {
        clientLogs: {
          click: { kinesis },
        },
      } = options[index || 0] // 옵션이 없는 경우 0번째 인덱스 옵션으로 데이터 수집
      kinesis && (await CartPageLog.ProductIdLinkCartOption.click({ productOption: kinesis }))

      const yaNative = getYaNative()
      if (isNative(yaNative)) {
        yaNative.deepLink({ link: `yanoljamotel://leisure/detail?idx=${itemId}` })
      } else {
        location.href = `${conf.leisure.url}/leisure/${itemId}`
      }
    },
    [itemId, options]
  )

  return (
    <div className="rounded-16 bg-static-white p-16 pf-pc:p-24">
      {/* 그룹 헤더 */}
      <div className="pb-16">
        {/* 국내레저 Badge */}
        <ProductBadge type="filled_secondary" size="medium" className="mb-6 px-6 py-2">
          국내레저
        </ProductBadge>

        {/* 타이틀 */}
        <div
          className="cursor-pointer text-text-neutral-main typography-subtitle-18-bold"
          onClick={() => onTitleClick()}
        >
          {itemTitle}
        </div>
      </div>
      <Divider size="small" type="horizontal" className="mb-20" />

      {/* 아이템 목록 */}
      <div className="flex flex-col gap-40">
        {options.map((option, index) => (
          <LeisureOption key={index} option={option} onTitleClick={() => onTitleClick(index)} />
        ))}
      </div>
    </div>
  )
}

export default LeisureItem
